import { RuleAction } from "./RuleAction";

// Helper function to get defined attributes for comparison
export const getDefinedAttributes = (
  element: HTMLElement,
  action: RuleAction
): Record<string, boolean> => {
  const comparisons: Record<string, boolean> = {};

  // Only add tagName comparison if action.tagName is defined
  if (action.tagName) {
    comparisons.tagName =
      element.tagName.toLowerCase() === action.tagName.toLowerCase();
  }

  // Only add attribute comparisons if they exist in both element and action
  if (action.attributes.id && element.id) {
    comparisons.id = element.id === action.attributes.id;
  }

  if (action.attributes.class && element.className) {
    comparisons.class = element.className === action.attributes.class;
  }

  if (action.attributes.type && element instanceof HTMLInputElement) {
    comparisons.type = element.type === action.attributes.type;
  }

  return comparisons;
};

export const isElementFullMatch =
  (action: RuleAction) =>
  (element: HTMLElement): boolean => {
    // First check CSS selector match
    if (!element.matches(action.selector)) {
      return false;
    }

    // Get only the defined comparisons
    const definedComparisons = getDefinedAttributes(element, action);

    // If no attributes to compare, return true if selector matched
    if (Object.keys(definedComparisons).length === 0) {
      return true;
    }

    // Return true only if all defined comparisons are true
    return Object.values(definedComparisons).every(Boolean);
  };
